/**
 * Section Tiles Context for managing section tiles visibility
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

interface SectionTilesContextType {
  isVisible: boolean;
  toggleVisibility: () => void;
  setVisibility: (visible: boolean) => void;
}

const SectionTilesContext = createContext<SectionTilesContextType | undefined>(undefined);

export const SectionTilesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisibleState] = useState<boolean>(true);

  const toggleVisibility = useCallback(() => {
    setIsVisibleState((prev) => !prev);
  }, []);

  const setVisibility = useCallback((visible: boolean) => {
    setIsVisibleState(visible);
  }, []);

  return (
    <SectionTilesContext.Provider value={{ isVisible, toggleVisibility, setVisibility }}>
      {children}
    </SectionTilesContext.Provider>
  );
};

export const useSectionTiles = () => {
  const context = useContext(SectionTilesContext);
  if (!context) {
    throw new Error('useSectionTiles must be used within SectionTilesProvider');
  }
  return context;
};